var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1484_35519)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 9.88141C28.7817 9.88141 36.0807 15.2981 39.4948 18.7677C40.1684 19.4524 40.1684 20.5477 39.4948 21.2323C36.0807 24.702 28.7817 30.1186 20 30.1186C11.2184 30.1186 3.91932 24.702 0.505254 21.2324C-0.168418 20.5477 -0.168418 19.4524 0.505254 18.7677C3.91932 15.2981 11.2184 9.88141 20 9.88141Z",
    fill: "#D1EFF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 30.1187C25.5885 30.1187 30.1188 25.5884 30.1188 20C30.1188 14.4116 25.5885 9.88126 20.0001 9.88126C14.4117 9.88126 9.88135 14.4116 9.88135 20C9.88135 25.5884 14.4117 30.1187 20.0001 30.1187Z",
    fill: "#76B7EB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M14.7647 11.3394C11.8376 13.1127 9.88135 16.3278 9.88135 20C9.88135 25.5884 14.4116 30.1186 19.9999 30.1186C22.4137 30.1186 24.6296 29.273 26.3688 27.8624C10.9881 31.5963 9.88135 16.8387 14.7647 11.3394Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 24.957C22.7377 24.957 24.957 22.7377 24.957 20C24.957 17.2623 22.7377 15.043 20 15.043C17.2623 15.043 15.043 17.2623 15.043 20C15.043 22.7377 17.2623 24.957 20 24.957Z",
    fill: "#38648C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8594 19.6893C26.1522 19.6893 27.2003 18.6412 27.2003 17.3484C27.2003 16.0556 26.1522 15.0076 24.8594 15.0076C23.5666 15.0076 22.5186 16.0556 22.5186 17.3484C22.5186 18.6412 23.5666 19.6893 24.8594 19.6893Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M0.861572 18.4127C4.25774 16.3157 11.8411 11.9522 20 11.9522C28.1589 11.9522 35.7423 16.3157 39.1384 18.4127C35.5899 14.9412 28.4876 9.88147 20 9.88147C11.5124 9.88147 4.41009 14.9412 0.861572 18.4127Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M26.2284 25.6521C26.0985 25.6521 25.9677 25.6091 25.859 25.5207L25.144 24.9391C24.8929 24.7348 24.855 24.3659 25.0591 24.1148C25.2633 23.8637 25.6324 23.8257 25.8834 24.0299L26.5985 24.6116C26.8496 24.8158 26.8875 25.1848 26.6833 25.4359C26.5676 25.5783 26.3987 25.6521 26.2284 25.6521Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M27.6801 22.9277C27.6235 22.9277 27.566 22.9195 27.509 22.9021L26.6273 22.6333C26.3178 22.5389 26.1434 22.2115 26.2378 21.902C26.3322 21.5924 26.6594 21.4182 26.9691 21.5124L27.8508 21.7812C28.1604 21.8756 28.3347 22.2031 28.2404 22.5126C28.1633 22.7652 27.9311 22.9277 27.6801 22.9277Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M19.2616 28.5807C19.2436 28.5807 19.2254 28.5798 19.207 28.5782C18.8848 28.5484 18.6477 28.263 18.6776 27.9408L18.7624 27.0229C18.7922 26.7006 19.0777 26.4644 19.3998 26.4933C19.722 26.5231 19.9591 26.8085 19.9292 27.1308L19.8444 28.0487C19.8163 28.3526 19.5609 28.5807 19.2616 28.5807Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M12.2224 22.5801C11.9612 22.5801 11.723 22.4042 11.6552 22.1395C11.5748 21.8261 11.7638 21.5068 12.0773 21.4265L12.9702 21.1976C13.2841 21.1173 13.603 21.3062 13.6833 21.6197C13.7637 21.9331 13.5747 22.2524 13.2612 22.3328L12.3683 22.5617C12.3195 22.5741 12.2706 22.5801 12.2224 22.5801Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M16.2159 14.5706C16.0212 14.5706 15.8307 14.4736 15.7194 14.2966L15.2285 13.5164C15.0562 13.2426 15.1385 12.8808 15.4124 12.7084C15.6862 12.5361 16.0481 12.6183 16.2204 12.8923L16.7113 13.6726C16.8837 13.9464 16.8013 14.3082 16.5274 14.4805C16.4305 14.5415 16.3225 14.5706 16.2159 14.5706Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M23.2902 14.2867C23.1987 14.2867 23.1061 14.2653 23.0193 14.22C22.7325 14.0701 22.6215 13.7162 22.7713 13.4294L23.1981 12.6123C23.3479 12.3255 23.702 12.2147 23.9887 12.3642C24.2755 12.5141 24.3866 12.868 24.2368 13.1548L23.81 13.9719C23.7055 14.1721 23.5014 14.2867 23.2902 14.2867Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.61302 35.4292C6.09044 35.4292 5.56786 35.2299 5.16911 34.8311C4.37169 34.0337 4.37169 32.7408 5.16911 31.9434L31.9433 5.1692C32.7407 4.37178 34.0336 4.37178 34.831 5.1692C35.6284 5.96663 35.6284 7.25952 34.831 8.05694L8.05685 34.8311C7.65818 35.2299 7.1356 35.4292 6.61302 35.4292Z",
    fill: "#E38892"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1484_35519"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.a9cc697b9ff15d15ec89439ea375e383.svg";
export { ForwardRef as ReactComponent };